module.exports = __webpack_public_path__ + "img/brown-leaf.f1f48d10.svg";